import React from 'react';

export type BadgeVariant = 'info' | 'success' | 'warning' | 'danger' | 'neutral';

export interface BadgeProps {
  variant?: BadgeVariant;
  icon?: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * KERN Badge Component
 *
 * Usage:
 * <Badge variant="info">Information</Badge>
 * <Badge variant="success" icon>Erfolg</Badge>
 */
export function Badge({ variant = 'info', icon = false, children, className = '' }: BadgeProps) {
  const classes = ['kern-badge', `kern-badge--${variant}`, className].filter(Boolean).join(' ');

  return (
    <span className={classes}>
      {icon && <span className={`kern-icon kern-icon--${variant}`} aria-hidden="true" />}
      <span className="kern-label kern-label--small">{children}</span>
    </span>
  );
}

export default Badge;
